export default __webpack_public_path__ + "static/media/arrow-icon.fa6a51d3.svg";